// extracted by mini-css-extract-plugin
module.exports = {"container":"CopyPathButton-module--container--b7-BF","icon":"CopyPathButton-module--icon--QiBCT"};